import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';

const CustomTooltip = styled(({ children, className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }}>
        {children}
    </Tooltip>
))`
    & .MuiTooltip-tooltip {
        background-color: #fff;
        color: #000;
        font-weight: normal;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        border: 1px solid #ddd;
        font-size: 14px;
        padding: 10px;
        border-radius: 5px;
    }

    & .MuiTooltip-arrow {
        color: #fff;
    }
`;

export default CustomTooltip;
